import { render, staticRenderFns } from "./temp-curve.vue?vue&type=template&id=5ef35461&"
import script from "./temp-curve.vue?vue&type=script&lang=ts&"
export * from "./temp-curve.vue?vue&type=script&lang=ts&"
import style0 from "./temp-curve.vue?vue&type=style&index=0&id=5ef35461&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports